import React from 'react';

// eslint-disable-next-line max-len
const LINEUP_LOGO = '/themes/theme/lineup/lineup_logo.png';
const LINEUP_DARK_LOGO = '/themes/theme/lineup/lineup_dark_logo.png';


const LINEUPTheme = {
  headerLogo: {
    src: LINEUP_LOGO,
    alt: 'LINEUP Logo',
    size: 70,
  },
  darkLogo: {
    src: LINEUP_DARK_LOGO,
    alt: 'LINEUP Logo',
    size: 70,
  },
  linkStyle: {
    color: '#fff',
    fontWeight: 800,
    fontSize: '120%',
  },
  headerStyle: {
    backgroundColor: '#000',
    borderBottom: '4px solid #000',
    height: 80,
  },
  title: 'LineupSports',
  isLightOnDark: true,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="150"
        src={LINEUP_DARK_LOGO} alt="LINEUP Logo"
      />
      <br /><br />
    </div>
  ),
  shareSite: 'https://lineupr.dyzio.co',
  isFullWhiteLabel: true,
};

export default LINEUPTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/lineup.js
 **/